<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
  [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
  [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros
    [name]="'filtros.periodo' | translate"
    [array]="periodos"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="cambioPeriodo($event)"
    [icono]="'calendar_month'"
    [click]="false"
  />

  <div contenido class="classContenedor">
    <app-contenedor-elementos [header]="header" class="zonaTablas">
      <mat-icon iconos class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
        [matMenuTriggerFor]="menuTable">
          more_vert
      </mat-icon>
      <div body class="tabla">
        <div class="tabla1">
          @if(verTabla){
            <table class="tabla-aleema">
              <thead>
                <tr>
                  @if (volatilidad233) {
                    @for (encabezados of volatilidad233.columnas; track $index) {
                      <th>
                        {{encabezados}}
                      </th>
                    }
                  }
                </tr>
              </thead>
              <tbody>
                @if (volatilidad233) {
                  @for (fila of volatilidad233.filas; track $index) {
                    @if (fila.visible && fila.type !== 'titulo' && fila.type !== 'blank') {
                      <tr>
                        <td style="white-space: pre;"
                        [ngClass]="{'total': fila.type === 'subtotal' || fila.suma}">
                          @if (fila.expandible){
                            <mat-icon class="iconoMen" (click)="showAndHide(fila, volatilidad233)">
                              {{fila.expandido?'expand_less':'expand_more'}}
                            </mat-icon>
                          }
                          {{fila.descripcion}}
                        </td>
                        @for (banda of fila.bandasValue; track $index) {
                          <td
                          [ngClass]="{
                            'bordersNoLaterales': banda === null,
                            'total': fila.type === 'subtotal' || fila.suma
                          }">
                            {{banda | formaterNumber:fila.decimales??0:',':'.'}}
                          </td>
                        }
                      </tr>
                    }@else if(fila.type === 'titulo'){
                      <tr>
                        <td [colSpan]="(fila.bandas.length+3)">
                          {{fila.descripcion}}
                        </td>
                      </tr>
                    }@else if(fila.type === 'blank'){
                      <tr style="height: 15px;">
                        <td [colSpan]="(fila.bandas.length+3)">
                        </td>
                      </tr>
                    }
                  }
                }
              </tbody>
            </table>
          }@else{
            <app-skeleton-table/>
          }
        </div>
        <div class="tabla1">
          @if(verTabla){
            <table class="tabla-aleema">
              <thead>
                <tr>
                  @if (volatilidad4) {
                    @for (encabezados of volatilidad4.columnas; track $index) {
                      <th>
                        {{encabezados}}
                      </th>
                    }
                  }
                </tr>
              </thead>
              <tbody>
                @if (volatilidad4) {
                  @for (fila of volatilidad4.filas; track $index) {
                    @if (fila.visible && fila.type !== 'titulo' && fila.type !== 'blank') {
                      <tr>
                        <td style="white-space: pre;"
                        [ngClass]="{'total': fila.type === 'subtotal' || fila.suma}">
                          @if (fila.expandible){
                            <mat-icon class="iconoMen" (click)="showAndHide(fila, volatilidad4)">
                              {{fila.expandido?'expand_less':'expand_more'}}
                            </mat-icon>
                          }
                          {{fila.descripcion}}
                        </td>
                        @for (banda of fila.bandasValue; track $index) {
                          <td
                          [ngClass]="{
                            'bordersNoLaterales': banda === null,
                            'total': fila.type === 'subtotal' || fila.suma
                          }">
                            {{banda | formaterNumber:fila.decimales??0:',':'.'}}
                          </td>
                        }
                      </tr>
                    }@else if(fila.type === 'titulo'){
                      <tr>
                        <td [colSpan]="(fila.bandas.length+3)">
                          {{fila.descripcion}}
                        </td>
                      </tr>
                    }@else if(fila.type === 'blank'){
                      <tr style="height: 15px;">
                        <td [colSpan]="(fila.bandas.length+3)">
                        </td>
                      </tr>
                    }
                  }
                }
              </tbody>
            </table>
          }@else{
            <app-skeleton-table/>
          }
        </div>
      </div>
    </app-contenedor-elementos>
  </div>
</app-esqueleto-tableros>

<mat-menu #menuTable="matMenu">
  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu"
  (click)="exportExcel()">
    <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
    <span>{{'menu.Exportar'|translate}}</span>
  </button>
</mat-menu>